let siteUrl;
siteUrl = process.env.SITE_URL;
export const Config = {
  APPURL: process.env.APP_URL,
  ENV: process.env.APP_ENV,
  HTML_FIVE_MODE: process.env.HTML_FIVE_MODE || "off",
  SITEURL: siteUrl,
  PUSHER_KEY: process.env.PUSHER_KEY,
};

// CARTO requires an API key on basemap tiles as of 2026-09; without one they
// serve a 200 with "API KEY REQUIRED" watermarked into the tile image itself,
// so there is no request error to detect. Shared by every map component --
// change the provider here, not at the call sites.
export const BASEMAP = Object.freeze({
  url: `https://basemaps.cartocdn.com/rastertiles/light_all/{z}/{x}/{y}{r}.png?key=${process.env.CARTO_API_KEY}`,
  attribution:
    '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
  maxZoom: 20,
});
